import type {
  CaseListItem,
  ClientListItem,
  ContactListItem,
  DocumentTypeDto,
  ProjectListItem,
  TaskTemplateDto,
  UserDto,
} from '@lawyer/shared'
import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { qk } from '../lib/queryClient'

/** Reference data for pickers. Cached longer than page data — it changes rarely. */
const LOOKUP_STALE_TIME = 5 * 60 * 1000

export const useUsers = () =>
  useQuery({
    queryKey: qk.users('lookup'),
    queryFn: () => api.get<UserDto[]>('/users'),
    staleTime: LOOKUP_STALE_TIME,
  })

export const useClientOptions = () =>
  useQuery({
    queryKey: qk.clients('lookup'),
    queryFn: () => api.get<ClientListItem[]>('/clients'),
    staleTime: LOOKUP_STALE_TIME,
  })

export const useCaseOptions = () =>
  useQuery({
    queryKey: qk.cases('lookup'),
    queryFn: () => api.get<CaseListItem[]>('/cases'),
    staleTime: LOOKUP_STALE_TIME,
  })

export const useProjectOptions = () =>
  useQuery({
    queryKey: qk.projects('lookup'),
    queryFn: () => api.get<ProjectListItem[]>('/projects'),
    staleTime: LOOKUP_STALE_TIME,
  })

export const useContactOptions = () =>
  useQuery({
    queryKey: qk.contacts('lookup'),
    queryFn: () => api.get<ContactListItem[]>('/contacts'),
    staleTime: LOOKUP_STALE_TIME,
  })

export const useTemplates = () =>
  useQuery({
    queryKey: qk.templates,
    queryFn: () => api.get<TaskTemplateDto[]>('/task-templates'),
    staleTime: LOOKUP_STALE_TIME,
  })

export const useDocumentTypes = () =>
  useQuery({
    queryKey: qk.documentTypes,
    queryFn: () => api.get<DocumentTypeDto[]>('/document-types'),
    staleTime: LOOKUP_STALE_TIME,
  })
